import {
	AUTHENTICATE,
	LOGOUT,
	ADDINTEREST,
	SETINTERESTS,
	ADDINTERESTUNIT,
	DELETEINTERESTUNIT,
	ADDINTERESTRESALE,
	DELETEINTERESTRESALE,
	SETNAVIGATE,
	CURRENCY,
	LOADINGHOME,
} from "./actionTypes";

const INITIAL_STATE = {
	token: "",
	userType: "",
	user_name: "",
	currency: "",
	navigateTo: "",
	interestsResales: [],
	interestsUnits: [],
	permissions: [],
	lang: "",
	system: "Dynamic",
	getSetting: true,
	systemId: "",
	userId: "",
	loadingHome: false,
	loadedBefore: false,
};

const AuthReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case LOADINGHOME:
			return {
				...state,
				loadingHome: action.payload.loadingHome,
				loadedBefore: action.payload.loadedBefore,
			};
		case AUTHENTICATE:
			return { ...state, ...action.payload };
		case LOGOUT:
			return {
				currency: state.currency,
				token: "",
				userType: "",
				user_name: "",
				navigateTo: "",
				interestsResales: [],
				interestsUnits: [],
				permissions: [],
				lang: state.lang,
				system: "Dynamic",
				getSetting: true,
				systemId: "",
				userId: "",
				loadingHome: false,
			};
		case SETNAVIGATE:
			return { ...state, navigateTo: action.payload };
		case SETINTERESTS:
			return { ...state, ...action.payload };
		case CURRENCY:
			return {
				...state,
				currency: action.payload,
			};
		case ADDINTEREST:
			return { ...state, ...action.payload };
		case ADDINTERESTUNIT:
			return {
				...state,
				interestsUnits: [...state.interestsUnits, action.payload.id],
			};
		case DELETEINTERESTUNIT:
			const updatedInterests = state.interestsUnits.filter(
				(data) => data !== action.payload.id
			);
			return { ...state, interestsUnits: [...updatedInterests] };
		case ADDINTERESTRESALE:
			return {
				...state,
				interestsResales: [...state.interestsResales, action.payload.id],
			};
		case DELETEINTERESTRESALE:
			const updatedInterestsResales = state.interestsResales.filter(
				(data) => data !== action.payload.id
			);
			return { ...state, interestsResales: [...updatedInterestsResales] };
		default:
			return state;
	}
};

export default AuthReducer;
